/** Buddy assistant on/off. Explicit choice wins; default ON for accounts with a
 * company (legacy users without the field count as company users), OFF for
 * solo accounts (company_id === null). Mirrors backend admin.buddy_effective. */
export const buddyEnabled = (user) => {
  if (!user) return false;
  if (user.buddy_enabled === true || user.buddy_enabled === false) return user.buddy_enabled;
  return user.company_id !== null;
};
